import React from "react"
import Layout from "../../../components/layout"
import { Link } from "gatsby"

export default (props) => (
  <Layout location={props.location}>
    <div className="row">
      <div className="col-md-12">
        <div className="page-header">
          <h1>
            GET /spaces/{"{"}spaceId{"}"}/activemeeting
          </h1>
        </div>
        <p>Get the information about active meeting for specified space.</p>
        <h2>URL Parameters</h2>
        <div className="table-responsive">
        <p>None.</p>
        </div>
        <h2>Body Parameters</h2>
        <p>None.</p>
        <h2>Authentication</h2>
        <p>JwtAuthenticator, Oauth2Authenticator, AnonymousAuthenticator</p>
        <h2>Example Request</h2>
        <h4>URL</h4>
        <pre className="nginx">
          GET https://spacesapis.avayacloud.com/api/spaces/{"{"}inviteId{"}"}/activemeeting
        </pre>
        <h4>Headers</h4>
        <pre className="javascript">
          Authorization: "jwt
          eyJhbGciOiJSUzI1NiIsIdfgdfgnR5cCI6IkpXVCJ9.eyJ1c2VyX2lkX3NpZyI6ImxPWHpxNzVzR3J3X0xwWEMyRGRMakhyYXJlWVhyTzFMdEZHZkhkOWNkTXciLCJwcm9kdWN0X3R5cGUiOiJhY2NvdW50cyIsImxhc3R1cGRhdGV0aW1lIjoiMjAxNy0wMS0zMFQxMzo1ODo0Ny4yMDYiLCJpc3MiOiJ6YW5nLmlvIiwicHVibGlja2V5aWQiOiJhZ3h6Zm05dVpYTnVZVEl3TVRSeUdnc1NEVWRLZDNSUWRXSnNhV05MWlhrdfgdWdJQ2dsUEtFakFvTSIsImV4cCI6MTQ5NTM5MTIwMywidXNlcl9pZCI6ImFneHpmbTl1WlhOdVlUSXdNVFJ5RVFzU0JGVnpaWElZZ0lEQXMtX25fUW9NIiwidmVyIjoiMi4wIn0.SqZpw1uPIebqW3qlDsm0-DWYFKEH0SgPwtD-tSESWOF-5hLkZMqJH28ooWux2S7s9riIew7pTVPnZpTgJa5zHcEAG0gXSEJVOqmpGp_4ufM8YtZoZMpBFjyAkwyAt-ILkGUYIo0GU5WyzMPLV8YLXfgdfgOgkE2MGGOajBkjPmC2Db3pA0D0M9k-21EL1gwWBC5YIq0PDAkgulegwl6khRmB8irJQ-dfg-d-KV9eYfFpsCdJKRGzSfqg"
        </pre>
        <p>Or</p>
        <pre className="javascript">
          Authorization: "bearer f746696f5de4528u128ae2f274eea253e8a7943a"
        </pre>
        <h2>Example Response</h2>
        <pre className="json">
{`{
    "sender": {
      "_id": "5f2276a8fe5c16664f01c5be",
      "type": "spaceserver"
    },
    "content": {
      "endTime": null,
      "mediaMode": "video",
      "virtualEndTime": null,
      "meetingStatus": "active",
      "bodyText": "",
      "attendees": [
        {
          "joinTime": "2020-08-10T11:01:27.999Z",
          "_id": "5f0426ccaa4a347af9994cdf",
          "type": "user",
          "username": "example@avaya.com",
          "displayname": "example",
          "picture_url": "https://storage.googleapis.com/onesna/pictures/pfpic_example_3da9345d-6038-4667-9f3d-f79a47b1d05c"
        }
      ],
      "startTime": "2020-08-10T11:01:26.118Z",
      "recordings": [],
      "data": []
    },
    "chatCount": 0,
    "likeCount": 0,
    "status": 0,
    "_id": "5f312906cbdf94015d9f0fde",
    "topicId": "5f2276a8fe5c16664f01c5be",
    "category": "meeting",
    "created": "2020-08-10T11:01:26.119Z"
}`}
        </pre>
      </div>
    </div>
  </Layout>
)
